import deburr from 'lodash.deburr';

const strippedString = (string) => {
    return deburr((string || '').toLowerCase());
};

export { strippedString };
